module.exports = __webpack_public_path__ + "static/media/400037_02.ae14a577.png";